import { FC } from 'react';

import { WidgetRenderer } from '~/widgets/WidgetRenderer';

import {
  MFAttachedDocumentsContextPropsType,
  MFAttachedDocumentsProvider,
} from '../providers/MFAttachedDocumentsProvider';
import { MFBaseProvider } from '../providers/MFBaseProvider';

const MFAttachedDocuments: FC<MFAttachedDocumentsContextPropsType> = (props) => {
  return (
    <MFBaseProvider {...props}>
      <MFAttachedDocumentsProvider {...props}>
        <WidgetRenderer />
      </MFAttachedDocumentsProvider>
    </MFBaseProvider>
  );
};

export default MFAttachedDocuments;
